// extracted by mini-css-extract-plugin
export default {"mCard":"TC-z","image":"UC-z","imageNoBackground":"VC-z","imageHasCategory":"WC-z","fullWidth":"XC-z"};